import { utilsModule } from "../utils-module";

utilsModule.factory('SidebarService',function(){


	var isScreenLg = function () { return window.screen.availWidth >= 780; };

	return {

		isLeftBarOpened : function(){
			return (<any>window).$("#wrapper").hasClass("toggled");
		},

		toggleLeftbar : function(){			
	        (<any>window).$("#wrapper").toggleClass("toggled");
		},

		closeLeftbar : function(){
			(<any>window).$("#wrapper").removeClass("toggled");
		},

		openLeftbar : function(){
			(<any>window).$("#wrapper").addClass("toggled");
		},

		isRightBarOpened : function(){
			return (<any>window).$("#wrapper").hasClass("toggled-right");
		},

		toggleRightbar : function(){
			(<any>window).$("#wrapper").toggleClass("toggled-right");
		},

		closeRightbar : function(){
			(<any>window).$("#wrapper").removeClass("toggled-right");
		},

		openRightbar : function(){
			(<any>window).$("#wrapper").addClass("toggled-right");
		},

		closeAllSideBars : function(){
			this.closeLeftbar();
			this.closeRightbar();
		},

		isThereAanyOpenedSideBar : function(){
			return this.isLeftBarOpened() || this.isRightBarOpened();
		}

	}

});